export const LOCALSTORAGE_KEY_IMPERSONATOR_ID = 'impersonatorId';
export const LOCALSTORAGE_KEY_LOGOUT = 'logout';
